define("shared/helpers/json-stringify", ["exports", "@ember/component/helper", "@ember/template"], function (_exports, _helper, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.jsonStringify = jsonStringify;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/template"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class LaterHelpers
   * @extends Helpers
   */
  /**
   * Takes a json value and turns it into a string
   *
   * @method json-stringify
   */
  function jsonStringify(_ref) {
    let [value] = _ref;
    return (0, _template.htmlSafe)(`<pre>${JSON.stringify(value, undefined, 2)}</pre>`); // Pretty-print with 2 spaces
  }
  const jsonStringifyHelper = (0, _helper.helper)(jsonStringify);
  var _default = _exports.default = jsonStringifyHelper;
});